import { useLayoutEffect, useState } from "react";
import { theme } from "./themes";

export type Device = "mobile" | "tablet" | "desktop";

export const useDevice = (): Device => {
  const breakpoints = theme.breakpoints.map((bp) => Number.parseInt(bp));

  const determineDevice = () => {
    if (window.innerWidth <= breakpoints[0]) {
      return "mobile";
    } else if (window.innerWidth >= breakpoints[2]) {
      return "desktop";
    } else {
      return "tablet";
    }
  };

  const [device, setDevice] = useState<Device>(determineDevice());

  useLayoutEffect(() => {
    const handleResize = () => {
      setDevice(determineDevice());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return device;
};
